// en_pms_checkin_stay.ts
// Tłumaczenia dla PMS.Checkin.tsx i PMS.Stay.tsx (oba ekrany Front Desk)

export const enPmsCheckinStay = {

  // ── Zameldowanie (Checkin) ────────────────────────────────────────────────
  checkin: {
    title:               "Front Desk",
    arrivalsToday:       "Arrivals today",
    preCheckIn:          "Pre check-in",
    earlyCheckIn:        "Early check-in",
    depositRule:         "Deposit rule",
    depositRuleRequired: "Deposit rule is required.",
    documentType:        "Document type",
    passport:            "Passport",
    idCard:              "ID card",
    preauth:             "Pre-authorisation",
    searchPlaceholder:   "Name, booking number, room, phone, email",
    readyRoom:           "Ready room",
    noReadyRoom:         "No ready room",
    noRoom:              "No room",
    missing:             "Missing",
    garage:              "Garage",
    messages: {
      completed:          "Check-in completed. Key coding is ready.",
      completedSimple:    "Check-in completed.",
      failed:             "Check-in failed.",
      documentRegistered: "Guest document registered and verified.",
      documentFailed:     "Document registration failed.",
    },
  },

  // ── Zarządzanie pobytem (Stay) ────────────────────────────────────────────
  stay: {
    title:       "Stay management",
    description: "Check-ins, stays, room moves, late checkout and checkout in one view.",
    inHouseStays:"In-house stays",
    frontOffice: "Front Office",
    frontOfficeActions:"Front Office actions",
    checkoutSettlement:"Checkout settlement",
    selectStay:  "Select a stay once, then continue with late checkout, room move or checkout.",
    keepVisible: "Keep arrivals and activity visible without switching pages.",
    lateCheckout: {
      title:         "Late checkout",
      description:   "Extend active stays and post the charge to folio.",
      applied:       "Late checkout applied",
      workflowActive:"Late checkout workflow active. The active stay is already preselected.",
    },
    roomMove: {
      title:         "Room move",
      description:   "Move the guest to another ready room and issue a new key.",
      completed:     "Room move completed and a new key issued.",
      failed:        "Room move failed.",
      selectRoom:    "Select a ready room before moving the guest.",
    },
    checkout: {
      title:         "Checkout",
      settle:        "Settle the folio, print or email the invoice, then finish checkout.",
      failed:        "Checkout failed.",
      settled:       "Checkout settled and invoice generated.",
      workflowActive:"Checkout workflow active. Review the folio and close the stay.",
    },
  },

} as const;

export default enPmsCheckinStay;
